import {
  __name
} from "./chunk-7QVYU63E.js";

// src/dashboard-config.ts
function defineDashboardConfig(config) {
  return config;
}
__name(defineDashboardConfig, "defineDashboardConfig");

// src/use-dashboard.ts
import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
var DEFAULT_REFRESH_INTERVAL = 3e5;
function useDashboard(config, fetchFn, options) {
  const [period, setPeriodState] = useState(options?.period ?? config.defaultPeriod ?? "month");
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastRefreshed, setLastRefreshed] = useState(null);
  const refreshInterval = config.refreshInterval ?? DEFAULT_REFRESH_INTERVAL;
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [
      "dashboard",
      config.resource,
      period
    ],
    queryFn: /* @__PURE__ */ __name(async () => {
      const result = await fetchFn(period);
      setLastRefreshed(/* @__PURE__ */ new Date());
      return result;
    }, "queryFn"),
    refetchInterval: refreshInterval,
    staleTime: refreshInterval
  });
  const refresh = useCallback(async () => {
    setIsRefreshing(true);
    try {
      await refetch();
    } finally {
      setIsRefreshing(false);
    }
  }, [
    refetch
  ]);
  const setPeriod = useCallback((p) => {
    setPeriodState(p);
  }, []);
  return {
    metrics: data,
    isRefreshing,
    lastRefreshed,
    period,
    setPeriod,
    refresh,
    isLoading,
    isError,
    error
  };
}
__name(useDashboard, "useDashboard");
export {
  defineDashboardConfig,
  useDashboard
};
//# sourceMappingURL=index.js.map